import React, { useEffect } from 'react';
import { Check, FolderOpen } from 'lucide-react';
import { useSlotAssetGeneratorStore } from '../../store/slotAssetGeneratorStore';

export const SlotToastBar: React.FC = () => {
  const toasts = useSlotAssetGeneratorStore((s) => s.toasts);
  const removeToast = useSlotAssetGeneratorStore((s) => s.removeToast);

  // Auto-dismiss after 5s
  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((toast) =>
      setTimeout(() => removeToast(toast.id), 5000)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts, removeToast]);

  if (toasts.length === 0) return null;

  return (
    <div className="absolute bottom-4 left-4 right-4 z-[120] space-y-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="pointer-events-auto flex items-center gap-2 px-3 py-2 rounded-lg bg-green-900/90 border border-green-700/50 text-xs animate-slideUp"
        >
          <Check size={14} className="text-green-400 flex-shrink-0" />
          <span className="text-green-200 flex-1 min-w-0 truncate">
            {toast.componentName} saved to {toast.savedPath}
          </span>
          <button
            onClick={() => {
              console.log('Open:', toast.savedPath);
            }}
            className="text-green-400 hover:text-green-200 flex items-center gap-1 flex-shrink-0"
          >
            <FolderOpen size={12} />
            Open
          </button>
        </div>
      ))}
    </div>
  );
};
